




























































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import ListingCategorySelector from './ListingCategorySelector'
import ListingTypeSelector from './ListingTypeSelector'
import { matchSort } from  '@utils/sort.coffee'

settings =
  name: "EventStep"

  vue:
    props: ['wizard']
    mixins: [WizardService.step()]
    components: { ListingCategorySelector, ListingTypeSelector }

    data: ->
      searchTime: null

      setListingClasses: false
      setListingTypes: false
      setListingCategoryTags: false

      listingClassOptions: []
      listingClassSearch: ''

      listingTypeOptions: []
      listingTypeSearch: ''

      listingCategoryOptions: []
      listingCategorySearch: ''

    mounted: ->
      @initializeSetListingTypes()
      @initializeSetListingCategoryTags()

      setTimeout(() =>
        @wizard.scrollStepToSection("#section-#{@$route.query.section}") if @$route.query.section
      , 300)

    computed:
      actionsForListingCategorySelector: ->
        {
          select: @selectListingCategory,
          unselect: @unselectListingCategory,
          selectAll: @selectAllListingCategories,
          unselectAll: @unselectAllListingCategories,
        }
      actionsForListingTypeSelector: ->
        {
          select: @selectListingType,
          unselect: @unselectListingType,
          selectAll: @selectAllListingTypes,
          unselectAll: @unselectAllListingTypes,
        }

    methods:
      initializeSetListingTypes: ->
        { types } = @wizard.campaignData.target.listing
        @setListingTypes = true if types.length

      initializeSetListingCategoryTags: ->
        { category_tags } = @wizard.campaignData.target.listing
        @setListingCategoryTags = true if category_tags.length

      selectListingCategory: (option) ->
        @wizard.campaignData.target.listing.category_tags.push option.key
      unselectListingCategory: (option) ->
        @wizard.campaignData.target.listing.category_tags = @wizard.campaignData.target.listing.category_tags.filter((category) -> category isnt option.key)
      selectAllListingCategories: (options) ->
        @wizard.campaignData.target.listing.category_tags = options.map((option) -> option.key)
      unselectAllListingCategories: ->
        @wizard.campaignData.target.listing.category_tags = []

      selectListingType: (option) ->
        @wizard.campaignData.target.listing.types.push option.key
      unselectListingType: (option) ->
        @wizard.campaignData.target.listing.types = @wizard.campaignData.target.listing.types.filter((type) -> type isnt option.key)
      selectAllListingTypes: (options) ->
        @wizard.campaignData.target.listing.types = options.map((option) -> option.key)
      unselectAllListingTypes: ->
        @wizard.campaignData.target.listing.types = []

      hiToggleSetListingTypes: (value) ->
        @setListingTypes = value

        if value
          @wizard.scrollStepToSection('#section-types') if !@setListingTypes
        else
          @unselectAllListingTypes()

      hiToggleSetListingCategoryTags: (value) ->
        @setListingCategoryTags = value

        if value
          @wizard.scrollStepToSection('#section-category-tags') if !@setListingCategoryTags
        else
          @unselectAllListingCategories()

export default VueOptions.vue settings
